import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';

import {CourseVideoForm} from 'src/app/course-video/CourseVideoForm';
import {courseVideoDocumentTitle} from 'src/app/course-video/courseVideoHelpers';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const CreateCourseVideoPage = () => {
  useSetDocumentTitle(courseVideoDocumentTitle);

  return (
    <ContentWrapper>
      <CourseVideoForm mode="create" view="content" />
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.CourseVideoCreate(),
  element: <CreateCourseVideoPage />,
  module: ModuleEnum.Training,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});

export default CreateCourseVideoPage;
